import { HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import * as ViewModel from '@/core/presenter/viewModel';
import { TOKEN_SYMBOL_ICON_PATH } from '@/consts/imgPath';

interface IProps {
  tokenAsset?: ViewModel.IAsset;
  trxBalance: string;
  tokenBalance: string;
  tokenKrw: string;
  tokenPrice: number;
  onClickViewType: (viewType: HomeViewType) => void;
}

const DoubleSProperty = ({ tokenAsset, tokenBalance, tokenKrw, tokenPrice, onClickViewType }: IProps) => {
  return (
    <div className="coin-item cursor-pointer" id="gdfCoin" onClick={() => onClickViewType(HomeViewType.TOKEN)}>
      <img src={TOKEN_SYMBOL_ICON_PATH} alt="골든파이낸스" className="coin-icon" />
      <div className="coin-info">
        <p className="coin-name text-base font-semibold">{tokenAsset?.name}</p>
        <p className="coin-symbol text-sm font-normal">
          1 {tokenAsset?.symbol} = {tokenPrice.toLocaleString()}원
        </p>
      </div>
      <div className="coin-amount">
        <p className="coin-balance text-base font-semibold">
          {tokenBalance} {tokenAsset?.symbol}
        </p>
        <p className="coin-krw text-sm font-bold">{tokenKrw} 원</p>
      </div>
    </div>
  );
};

export default DoubleSProperty;
